import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import AIProtonState from "./AIProtonState";
import { AIProtonModel } from "@NA/Widgets/AIProton/AIProtonModel";

const initialState: AIProtonState = {
    isLoading: true,
    products: [],
    productsFBT:[],
    productsSimilar:[] //products
};

const reducer = {
    "HomePage/GetAIProton": (draft: Draft<AIProtonState>) => {
        draft.isLoading = true;
    },
    "Homepage/DispatchCompleteLoadAIProton": (
        draft: Draft<AIProtonState>,
        action: {
            products: AIProtonModel[];
        },
    ) => {
        draft.isLoading = false;
        draft.products = action.products;
    },
    "PDP/DispatchCompleteLoadAIProtonFBT": (
        draft: Draft<AIProtonState>,
        action: {
            productsFBT: AIProtonModel[];
        },
    ) => {
        draft.isLoading = false;
        draft.productsFBT = action.productsFBT;
    },
    "PDP/DispatchCompleteLoadAIProtonSimilar": (
        draft: Draft<AIProtonState>,
        action: {
            productsSimilar: AIProtonModel[];
        },
    ) => {
        draft.isLoading = false;
        draft.productsSimilar = action.productsSimilar;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);

